<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        :ripple="false"
        class="no-background-hover"
        style="height:24px !important;width:24px !important"
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil 
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="EPF Contribution"
      text="Update EPF Contribution"
      class="mb-0"
    >
      <v-container v-if="dialog">
        <v-row>
          <v-col
            cols="12"
            class="pb-0"
          >
            <span> Is Employee EPF Contribute? </span>
            <v-radio-group
              v-model="localEpfContribution.is_employee_contributed"
              class="mt-2"
              row
              @change="resetEmployeeEpfData"
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              /> 
            </v-radio-group>
          </v-col>

          <v-col
            v-if="localEpfContribution.is_employee_contributed"
            class="py-0"
          >
            <v-autocomplete
              v-model="employeeEpfContributionType"
              v-validate="localEpfContribution.is_employee_contributed ? 'required' : ''"
              label="Employee EPF Contribution Type"
              :error-messages="errors.collect('employeeEpfContributionType')"
              data-vv-name="employeeEpfContributionType"
              data-vv-as="employee EPF contribution type"
              clearable
              item-value="id"
              item-text="name"
              :items="epfContributionCategories"
              outlined
            />
          </v-col>

          <v-col
            v-if="localEpfContribution.is_employee_contributed && employeeEpfContributionType === 1"
            cols="12"
            class="pb-0"
          >
            <v-autocomplete
              v-model="localEpfContribution.employee_contribution_deduction_id"
              v-validate="employeeEpfContributionType === 1 ? 'required' : ''"
              label="Employee Epf Rate (Follow Government)"
              :error-messages="errors.collect('employee_contribution_deduction_id')"
              data-vv-name="employee_contribution_deduction_id"
              data-vv-as="employee follow government epf rate"
              clearable
              item-value="id"
              outlined
              :item-text="item => '['+item.code+'] - '+ item.name"
              :items="contributionDeductions"
              @change="localEpfContribution.employee_customized_rate = null; localEpfContribution.employee_customized_amount = 0;"
            />
          </v-col>

          <v-col
            v-if="localEpfContribution.is_employee_contributed && employeeEpfContributionType === 2"
            cols="12"
            class="pb-0"
          >
            <v-text-field
              v-model="localEpfContribution.employee_customized_rate"
              v-validate="employeeEpfContributionType === 2 ? 'required|oneDecimalValue|pointFive' : ''"
              :error-messages="errors.collect('employee_customized_rate')"
              data-vv-name="employee_customized_rate"
              data-vv-as="employee customized EPF rate"
              label="Employee Customized EPF Rate"
              type="number"
              suffix="%"
              outlined
              clearable
              @change="localEpfContribution.employee_contribution_deduction_id = null; localEpfContribution.employee_customized_amount = 0;"
            />
          </v-col>
          
          <v-col
            v-if="localEpfContribution.is_employee_contributed && employeeEpfContributionType === 3"
            cols="12"
            class="pb-0"
          >
            <v-text-field
              v-model="localEpfContribution.employee_customized_amount"
              v-validate="employeeEpfContributionType === 3 ? 'required' : ''"
              v-money="money"
              :error-messages="errors.collect('employee_customized_amount')"
              data-vv-name="employee_customized_amount"
              data-vv-as="employee customized EPF amount"
              label="Employee Customized EPF Amount"
              prefix="RM"
              outlined
              @change="localEpfContribution.employee_contribution_deduction_id = null; localEpfContribution.employee_customized_rate = null;"
            />
          </v-col>

          <v-col
            cols="12"
            class="pb-0"
          >
            <span> Is Employer EPF Contribute? </span>
            <v-radio-group
              v-model="localEpfContribution.is_employer_contributed"
              class="mt-2"
              row
              @change="resetEmployerEpfData"
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              /> 
            </v-radio-group>
          </v-col>

          <v-col
            v-if="localEpfContribution.is_employer_contributed"
            class="py-0"
          >
            <v-autocomplete
              v-model="employerEpfContributionType"
              v-validate="localEpfContribution.is_employer_contributed ? 'required' : ''"
              label="Employer EPF Contribution Type"
              :error-messages="errors.collect('employerEpfContributionType')"
              data-vv-name="employerEpfContributionType"
              data-vv-as="employer EPF contribution type"
              clearable
              item-value="id"
              item-text="name"
              :items="epfContributionCategories"
              outlined
            />
          </v-col>

          <v-col
            v-if="localEpfContribution.is_employer_contributed && employerEpfContributionType === 1"
            cols="12"
            class="pb-0"
          >
            <v-autocomplete
              v-model="localEpfContribution.employer_contribution_deduction_id"
              v-validate="employerEpfContributionType === 1 ? 'required' : ''"
              label="Employer Epf Rate (Follow Government)"
              :error-messages="errors.collect('employer_contribution_deduction_id')"
              data-vv-name="employer_contribution_deduction_id"
              data-vv-as="employer follow government epf rate"
              clearable
              outlined
              item-value="id"
              :item-text="item => '['+item.code+'] - '+ item.name"
              :items="filteredContributionDeductions"
              @change="localEpfContribution.employer_customized_rate = null; localEpfContribution.employer_customized_amount = 0;"
            />
          </v-col>

          <v-col
            v-if="localEpfContribution.is_employer_contributed && employerEpfContributionType === 2"
            cols="12"
            class="pb-0"
          >
            <v-text-field
              v-model="localEpfContribution.employer_customized_rate"
              v-validate="employerEpfContributionType === 2 ? 'required|oneDecimalValue|pointFive' : ''"
              :error-messages="errors.collect('employer_customized_rate')"
              data-vv-name="employer_customized_rate"
              data-vv-as="employer customized EPF rate"
              label="Employer Customized EPF Rate"
              type="number"
              suffix="%"
              clearable
              outlined
              @change="localEpfContribution.employer_contribution_deduction_id = null; localEpfContribution.employer_customized_amount = 0;"
            />
          </v-col>
          
          <v-col
            v-if="localEpfContribution.is_employer_contributed && employerEpfContributionType === 3"
            cols="12"
            class="pb-0"
          >
            <v-text-field
              v-model="localEpfContribution.employer_customized_amount"
              v-validate="employerEpfContributionType === 3 ? 'required' : ''"
              v-money="money"
              :error-messages="errors.collect('employer_customized_amount')"
              data-vv-name="employer_customized_amount"
              data-vv-as="employer customized EPF amount"
              label="Employer Customized EPF Amount"
              prefix="RM"
              outlined
              @change="localEpfContribution.employer_contribution_deduction_id = null; localEpfContribution.employer_customized_rate = null;"
            />
          </v-col>

          <v-col
            class="pb-0"
            cols="12"
          >
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
              max-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="startDateDisplay"
                  data-vv-name="startDateDisplay"
                  data-vv-as="start date"
                  label="Start date"
                  outlined
                  readonly
                  class="label-position"
                  v-on="on"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="localEpfContribution.start_date"
                no-title
                type="month"
                :min="companyEmployeeStartDate"
                @input="startDateMenu = false"
              />
            </v-menu>
          </v-col> 
        </v-row>
      </v-container>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          color="hrissecondary"    
          class="white--text px-10" 
          :loading="progressing"
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import Big from 'big.js'
  import { VMoney } from 'v-money'
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    directives: { money: VMoney },
    props: {
      epfContribution: {
        type: Object,
        required: true,
      },
      companyEmployeeStartDate: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        localEpfContribution: null,
        startDateMenu: false,
        mask: '####-##-##',
        contributionDeductions: [],
        employeeEpfContributionType: null,
        employerEpfContributionType: null,
        epfContributionCategories: [
          { id: 1, name: 'Follow Government' },
          { id: 2, name: 'By Custom Rate (%)' },
          { id: 3, name: 'By Custom Amount (RM)' },
        ],
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
      }
    },
    computed: {
      startDateDisplay () {
        return this.localEpfContribution.start_date ? this.$moment(this.localEpfContribution.start_date + '-01', 'YYYY-MM-DD').format('MMM YYYY') : ''
      },
      filteredContributionDeductions () {
        if (!this.localEpfContribution.employee_contribution_deduction_id) return this.contributionDeductions

        return this.contributionDeductions.filter(contributionDeduction => {
          return contributionDeduction.id === this.localEpfContribution.employee_contribution_deduction_id
        })
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return
        this.localEpfContribution = { ...this.epfContribution }
        if (this.localEpfContribution.start_date) { this.localEpfContribution.start_date = this.localEpfContribution.start_date.substring(0, 7) }

        if (this.localEpfContribution.employee_customized_rate) { this.localEpfContribution.employee_customized_rate = this.localEpfContribution.employee_customized_rate / 100 }
        if (this.localEpfContribution.employer_customized_rate) { this.localEpfContribution.employer_customized_rate = this.localEpfContribution.employer_customized_rate / 100 }

        if (this.localEpfContribution.employee_contribution_deduction_id) {
          this.employeeEpfContributionType = 1
        } else if (this.localEpfContribution.employee_customized_rate) {
          this.employeeEpfContributionType = 2
        } else {
          this.employeeEpfContributionType = 3
        }

        if (this.localEpfContribution.employer_contribution_deduction_id) {
          this.employerEpfContributionType = 1
        } else if (this.localEpfContribution.employer_customized_rate) {
          this.employerEpfContributionType = 2
        } else {
          this.employerEpfContributionType = 3
        }

        let _this = this

        this.$validator.extend('oneDecimalValue', {
          getMessage (field, args) {
            return 'Only 1 Decimals are allowed'
          },
          validate (value, args) {
            return _this.isValidNumbers(value)
          },
        })

        this.$validator.extend('pointFive', {
          getMessage (field, args) {
            return 'Only 0.5 is allowed'
          },
          validate (value, args) {
            if (value.toString().indexOf('.') > -1) {
              let arr = [...value.split('.')[1]]
              return arr[0] === '5' || arr[0] === '0'
            } else {
              return true
            }
          },
        })

        this.$api.contributionDeductions().list('?with=epf')
          .then(res => {
            this.contributionDeductions = res.data
          })
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            this.setProgressing(true)

            this.$api.companyEmployeeEpfContributions().update(this.localEpfContribution.id, this.prepareFormData())
              .then(res => {
                this.$snack({ message: res.data.status })
                this.$emit('updated')
                this.setProgressing(false)

                this.dialog = false
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          start_date: this.localEpfContribution.start_date + '-01',
          employee_contribution_deduction_id: this.employeeEpfContributionType === 1 ? this.localEpfContribution.employee_contribution_deduction_id : null,
          employee_customized_rate: this.employeeEpfContributionType === 2 ? this.localEpfContribution.employee_customized_rate : null,
          employee_customized_amount: this.employeeEpfContributionType === 3 ? this.localEpfContribution.employee_customized_amount.toString().replaceAll(',', '') : 0,
          employer_contribution_deduction_id: this.employerEpfContributionType === 1 ? this.localEpfContribution.employer_contribution_deduction_id : null,
          employer_customized_rate: this.employerEpfContributionType === 2 ? this.localEpfContribution.employer_customized_rate : null,
          employer_customized_amount: this.employerEpfContributionType === 3 ? this.localEpfContribution.employer_customized_amount.toString().replaceAll(',', '') : 0,
          is_employee_contributed: this.localEpfContribution.is_employee_contributed,
          is_employer_contributed: this.localEpfContribution.is_employer_contributed,
        }
      },

      isValidNumbers (value) {
        return (new Big(value).times(1000) % 100 === 0)
      },

      resetEmployeeEpfData () {
        if (!this.localEpfContribution.is_employee_contributed) {
          this.localEpfContribution.employee_contribution_deduction_id = null
          this.localEpfContribution.employee_customized_rate = null
          this.localEpfContribution.employee_customized_amount = 0
        }
      },

      resetEmployerEpfData () {
        if (!this.localEpfContribution.is_employer_contributed) {
          this.localEpfContribution.employer_contribution_deduction_id = null
          this.localEpfContribution.employer_customized_rate = null
          this.localEpfContribution.employer_customized_amount = 0
        }
      },
    },
  }
</script>

<style scoped>
.no-background-hover::before {
   background-color: transparent !important; 
}

.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
</style>
